import { useState } from "react";
import { Package } from "lucide-react";

export const ProductThumb = ({ product, color, className = "" }) => {
  const [failed, setFailed] = useState("");
  if (product.image_url && failed !== product.image_url)
    return <img src={product.image_url} alt={product.name} loading="lazy" className={`object-cover ${className}`} onError={() => setFailed(product.image_url)} />;
  return (
    <div className={`grid place-items-center font-display font-extrabold text-white ${className}`} style={{ background: color || "#3B82F6" }}>
      {product.name
        .split(" ")
        .slice(0, 2)
        .map((w) => w[0])
        .join("")
        .toUpperCase() || <Package />}
    </div>
  );
};

export const StatCard = ({ icon: Icon, label, value, hint, tone = "primary", testid }) => (
  <div className="rounded-2xl border bg-card p-5 fade-up" data-testid={testid}>
    <div className="flex items-center justify-between">
      <span className="text-sm text-muted-foreground font-medium">{label}</span>
      <span className={`h-9 w-9 rounded-xl grid place-items-center bg-${tone}/10 text-${tone}`}
        style={{ background: `hsl(var(--${tone}) / 0.12)`, color: `hsl(var(--${tone}))` }}>
        <Icon className="h-[18px] w-[18px]" />
      </span>
    </div>
    <div className="mt-3 font-mono font-bold text-2xl tracking-tight" data-testid={testid ? `${testid}-value` : undefined}>{value}</div>
    {hint && <div className="text-xs text-muted-foreground mt-1">{hint}</div>}
  </div>
);

export const PageWrap = ({ children, className = "" }) => <div className={`p-4 lg:p-6 space-y-6 ${className}`}>{children}</div>;

export const Empty = ({ icon: Icon = Package, text }) => (
  <div className="py-16 text-center text-muted-foreground">
    <Icon className="mx-auto h-10 w-10 mb-3 opacity-40" />
    <p className="text-sm">{text}</p>
  </div>
);
